import React from 'react';
import Hero from './Hero';
import NavbarStandard from './NavbarStandard';
import Partners from './Partners';
import Processes from './Processes';
import Services from './Services';
import Testimonial from './Testimonial';
import FooterStandard from './FooterStandard';
import { Helmet } from 'react-helmet';
const Landing = () => {
  return (
    <>
      <Helmet>
        <title>
          Вэб сайт хийх үйлчилгээ |Веб хийх үйлчилгээ | Website hiih | вэб сайт
          хийнэ | Вэб сайт хийдэг компани | Веб сайт | вебсайт хийнэ |
          маркетингийн агентлаг | shopify хөгжүүлэлт | ecommerce хөгжүүлэлт |
          e-commerce сайт хийх газар | Онлайн худалдааны сайт хийх | Веб хаяг |
          Вэб хаяг | Үнийн санал | Web hiine | Компанийн танилцуулага хийх |
          Байгуулагын танилцуулага вэбсайт хийх | Гар утасны апп | Гар утасны
          програм хийх | Online shop хийх | Гэгээн Софт ХХК | GegeeWeb
        </title>
        <meta charSet="UTF-8" />
        <meta
          name="description"
          content="Вэб сайт хийх үйлчилгээ | Веб хийх үйлчилгээ  | Website hiih | вэб сайт хийнэ | Вэб сайт
          хийдэг компани | Веб сайт | вебсайт хийнэ | маркетингийн агентлаг |
          shopify хөгжүүлэлт | ecommerce хөгжүүлэлт | e-commerce сайт хийх газар
          | Онлайн худалдааны сайт хийх | Веб хаяг | Вэб хаяг | Үнийн санал |
          Web hiine | Компанийн танилцуулага хийх | Байгуулагын танилцуулага
          вэбсайт хийх | Гар утасны апп | Гар утасны програм хийх | Online shop
          хийх | Гэгээн Софт ХХК| GegeeWeb |  "
        />
        <meta
          name="keywords"
          content="Вэб сайт хийх үйлчилгээ | Веб хийх үйлчилгээ  |  Website hiih | вэб сайт хийнэ | Вэб сайт
          хийдэг компани | Веб сайт | вебсайт хийнэ | маркетингийн агентлаг |
          shopify хөгжүүлэлт | ecommerce хөгжүүлэлт | e-commerce сайт хийх газар
          | Онлайн худалдааны сайт хийх | Веб хаяг | Вэб хаяг | Үнийн санал |
          Web hiine | Компанийн танилцуулага хийх | Байгуулагын танилцуулага
          вэбсайт хийх | Гар утасны апп | Гар утасны програм хийх | Online shop
          хийх | Гэгээн Софт ХХК  | GegeeWeb "
        />
        <meta name="author" content="Гэгээнсофт ххк" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/gegeensoft.png" />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/gegeensoft/image/upload/v1681274515/main-zurag_fpukxj.jpg"
        />
        <meta
          property="og:image:secure_url"
          content="https://res.cloudinary.com/gegeensoft/image/upload/v1681274515/main-zurag_fpukxj.jpg"
        />
        <meta property="og:image:type" content="image/jpg" />
        <meta property="og:image:width" content="400" />
        <meta property="og:image:height" content="300" />
        <meta property="og:url" content="https://www.gegee-web.site" />
        <meta property="og:article" content="Вэб сайт хийдэг компанийн тухай" />
        <meta
          property="og:title"
          content="Вэб сайт хийх үйлчилгээ | Website hiih | вэб сайт хийнэ | Вэб сайт | Веб сайт хөгжүүлэх | Веб сайт хийдэг компани | Веб сайт | вебсайт хийнэ | маркетингийн агентлаг |
          shopify хөгжүүлэлт | ecommerce хөгжүүлэлт | e-commerce сайт хийх газар
          | Онлайн худалдааны сайт хийх | Веб хаяг | Вэб хаяг | Үнийн санал |
          Web hiine | Компанийн танилцуулага хийх | Байгуулагын танилцуулага
          вэбсайт хийх | Гар утасны апп | Гар утасны програм хийх | Online shop
          хийх | Гэгээн Софт ХХК | GegeeWeb"
        />
        <meta
          property="og:description"
          content="Вэб сайт хийдэг компани. 99120224 | info@gegeensoft.mn | дижитал маркетингийн агентлаг | Вэб хуудас хөгжүүлэх үйлчилгээ  | Веб сайт | вэб сайт хийх үнийн санал | вэб сайт хийх | Веб сайт хийдэг компани"
        />
        <meta property="og:site_name" content="https://gegee-web.site" />
      </Helmet>
      <NavbarStandard />
      <Hero />
      <Partners />
      <Processes />
      <Services />
      <Testimonial />
      {/* <Cta /> */}
      <FooterStandard />
    </>
  );
};

export default Landing;
